import { PageContentWrapper } from "../../shared/styled/PageContentStyle";
import ProductsTabNavigations from "./ProductsTabNavigations";
import Title from "./Title";


const Products = () => {
    return (
        <PageContentWrapper>
            <Title />
            <ProductsTabNavigations />
        </PageContentWrapper>
    );
};

export default Products;
